export default __webpack_public_path__ + "files/BBM4.pdf";